var talksService = function () {
  this.getTalks = function () {
    return [
      {
        "id": "1",
        "titulo": "Cultura da Empatia: a base do Customer Experience",
        "palestrante": "Sandro Magaldi",
        "capa": "https://pocs.digitalpages.com.br/bv-super-app/palestras/cultura-da-empatia-a-base-do-customer-experience.png",
        "palestrante_foto": "https://pocs.digitalpages.com.br/bv-super-app/avatar/sandro-magaldi.png",
        "sobre": "O mercado vem focando cada vez mais na empatia com os clientes e parceiros. E, na busca por fidelizar e gerar lucros, o design pode ser o primeiro contato empático. Assim, essa palestra tem como objetivo olhar para o customer experience a partir do gerenciamento do produto por parte dos designers, focando na modelagem e nas métricas de uma experiência positiva para todos.",
        "local": "Av. das Nações Unidas, 14.171, São Paulo, SP – Auditório 1 – Térreo",
        "horario": "29 de Novembro - 09h30 às 10h30",
        "status": "happening",
        "disabled": false,
        "competencias": ["Empatia", "Orientação ao Cliente"]
      },
      {
        "id": "2",
        "titulo": "Novo líder",
        "palestrante": "Diego Feldberg",
        "capa": "https://pocs.digitalpages.com.br/bv-super-app/palestras/novo-lider.png",
        "palestrante_foto": "https://pocs.digitalpages.com.br/bv-super-app/avatar/diego-feldberg.png",
        "sobre": "Com a mudança do mercado, é preciso que os líderes mudem também. As novas lideranças precisam estar preparadas para um contexto disruptivo, no qual o objetivo deixa de ser somente ordem e lucros e passa a ser a gestão do capital humano e o interesse do cliente. Assim, essa palestra busca mostrar como as lideranças do Banco Votorantim encaram a nova cultura de centralidade no cliente e como isso impacta os times.",
        "local": "Av. das Nações Unidas, 14.171, São Paulo, SP – Auditório 1 – Térreo",
        "horario": "29 de Novembro - 11h00 às 12h30",
        "status": "not_started",
        "disabled": false,
        "competencias": ["Orientação ao Cliente", "Adaptação", "Liderança"]
      },
      {
        "id": "5",
        "titulo": "Por que mudamos tanto?",
        "palestrante": "Sandro Magaldi",
        "capa": "https://pocs.digitalpages.com.br/bv-super-app/palestras/por-que-mudamos-tanto.png",
        "palestrante_foto": "https://pocs.digitalpages.com.br/bv-super-app/avatar/sandro-magaldi.png",
        "sobre": "Para finalizar o evento, vamos explicar o que é a centralidade no cliente e como isso agora é parte da cultura organizacional do Banco Votorantim. Acreditamos na importância da experiência centrada no cliente como uma estratégia positiva de negócios e uma mudança na relação do consumo digital.",
        "local": "Av. das Nações Unidas, 14.171, São Paulo, SP – Auditório 1 – Térreo",
        "horario": "29 de Novembro - 14h30 às 16h00",
        "status": "not_started",
        "disabled": false,
        "competencias": ["Orientação ao Cliente", "Gestão de Mudança"]
      },
      {
        "id": "4",
        "titulo": "Você conhece nossos concorrentes?",
        "palestrante": "Diego Feldberg",
        "capa": "https://pocs.digitalpages.com.br/bv-super-app/palestras/voce-conhece-nossos-concorrentes.png",
        "palestrante_foto": "https://pocs.digitalpages.com.br/bv-super-app/avatar/diego-feldberg.png",
        "sobre": "Estamos em uma disputa constante no mercado corporativo, principalmente em relação a mudanças e ao contato com o cliente. Por isso, é necessário entender como funciona a concorrência, de forma a se atentar a pontos que possam ser melhorados nos produtos do Banco Votorantim. Assim, o objetivo dessa palestra é evidenciar a importância de conhecer não somente o nosso ecossistema, mas também estar antenado(a) com as novidades.",
        "local": "Av. das Nações Unidas, 14.171, São Paulo, SP – Auditório 1 – Térreo",
        "horario": "29 de Novembro - 16h30 às 18h00",
        "status": "not_started",
        "disabled": false,
        "competencias": ["Perspectiva de Negócio", "Orientação ao Cliente"]
      },
      {
        "id": "3",
        "titulo": "Gerando valor juntos: dos dados à IA e à inteligência coletiva",
        "palestrante": "Vinicius Vieira",
        "capa": "https://pocs.digitalpages.com.br/bv-super-app/palestras/gerando-valor-juntos-dos-dados-a-ia-e-a-inteligencia-coletiva.png",
        "palestrante_foto": "https://pocs.digitalpages.com.br/bv-super-app/avatar/vinicius-vieira.png",
        "sobre": "O impacto da Inteligência Artificial já é uma realidade, principalmente no mercado financeiro. Porém, uma coleta de dados sem objetivo gera uma desvalorização no trabalho de uma empresa. Assim, pensando em empresa, colaboradores e clientes, essa palestra tem como objetivo evidenciar a inteligência coletiva como um aspecto a ser implementado na cultura do Banco Votorantim, considerando a união de formas para a geração de valor.",
        "local": "Av. das Nações Unidas, 14.171, São Paulo, SP – Auditório 1 – Térreo",
        "horario": "28 de Novembro - 9h30 às 11h00",
        "status": "finished",
        "disabled": false,
        "competencias": ["Inovação", "Foco Empresarial"]
      },
      {
        "id": "6",
        "titulo": "Tecnologias Emergentes",
        "palestrante": "Renata Correa",
        "capa": "https://pocs.digitalpages.com.br/bv-super-app/palestras/tecnologias-emergentes.png",
        "palestrante_foto": "https://pocs.digitalpages.com.br/bv-super-app/avatar/diego-feldberg.png",
        "sobre": "As tecnologias emergentes devem alterar a vida das pessoas e transformar o cenário do trabalho, dos negócios e da economia global. Assim, essa palestra busca dar entendimento de quais são os elementos responsáveis por essas mudanças e como eles funcionam na prática.",
        "local": "Av. das Nações Unidas, 14.171, São Paulo, SP – Auditório 1 – Térreo",
        "horario": "28 de Novembro - 11h30 às 12h30",
        "status": "finished",
        "disabled": true,
        "competencias": ["Gestão de Tecnologias Emergentes"]
      },
      {
        "id": "7",
        "titulo": "Agilidade",
        "palestrante": "Reinaldo Nogueira",
        "capa": "https://pocs.digitalpages.com.br/bv-super-app/palestras/agilidade.png",
        "palestrante_foto": "https://pocs.digitalpages.com.br/bv-super-app/avatar/diego-feldberg.png",
        "sobre": "Integrar métodos ágeis e novas tecnologias aos fatores humanos, que incluem não só os colaboradores, mas também os objetivos e o propósito, é fundamental para o sucesso de uma companhia. Diante disso, essa palestra traz a importância de conhecer os sistemas e as metodologias, como o cuidado com tribos, squads e afins, que prometem facilitar e agilizar a atuação de líderes e de gestores.",
        "local": "Av. das Nações Unidas, 14.171, São Paulo, SP – Auditório 1 – Térreo",
        "horario": "28 de Novembro - 16h30 às 18h00",
        "status": "finished",
        "disabled": true,
        "competencias": ["Gestão de Métodos Ágeis", "Metodologias Empresariais"]
      }
    ]
  }

  return this;
}

var TalksService = new talksService();

export {
  TalksService
};